import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { AppConfigProvider } from './app/core/providers/app-config.provider';
import { API_SERVER_URL_TOKEN } from './app/core/tokens/api-server-url.token';
import { AUTH_PROVIDER_TOKEN, AuthProvider } from './app/core/tokens/auth-provider.token';

fetch('/assets/config/app.config.json')
  .then((response) => response.json())
  .then((config) => {
    const appConfigProvider = new AppConfigProvider(config);

    // Resolve the active auth provider from the runtime config.
    const authProvider: AuthProvider = (config.authProvider as AuthProvider) || 'Api';

    return bootstrapApplication(AppComponent, {
      ...appConfig,
      providers: [
        provideZoneChangeDetection(),...appConfig.providers!,
        { provide: AppConfigProvider, useValue: appConfigProvider },
        { provide: API_SERVER_URL_TOKEN, useValue: config.apiServerUrl },
        { provide: AUTH_PROVIDER_TOKEN, useValue: authProvider },
      ],
    });
  })
  .catch((err) => {});
